export const environment = {
  baseUrl: 'http://localhost:4200',
  deployedUrl: 'https://nettest.ekip.me',
  availableLangs: [
    { iso: 'sr_ME-Latn', name: 'Crnogorski' },
    { iso: 'en', name: 'English' },
  ],
  defaultLang: 'sr_ME-Latn',
  cms: {
    headers: {
      'Content-Type': 'application/json',
    },
    projectSlug: 'ekip_me',
    type: 'strapi',
    url: 'https://portal-api.nettest.org',
    routes: {
      articles: '/articles',
      export: '/export',
      exportQueue: '/dataStream',
      feedback: '/feedback',
      menus: '/header-menus',
      municipalities: '/municipalities',
      translations: '/ui-translations',
      images: '/assets/images',
      clearExport: '/dataStream/remove',
      cookiesProject: '/cookies/project',
      cookieConsents: '/cookie-consents',
      pages: '/pages',
      pagesProject: '/pages/project',
      projects: '/projects',
      scheduleExport: '/public/mobile',
      uploads: '/upload/files',
      versions: '/versions',
    },
  },
  controlServer: {
    headers: {
      'Content-Type': 'application/json',
      'X-Nettest-Client': 'ekip_me',
    },
    url: 'https://api.nettest.org',
    routes: {
      providers: '/nationalTable',
      history: '/reports/basic/history',
      result: '/measurementResult',
      measurementServer: '/measurementServer',
      settings: '/settings',
    },
  },
  cookieWidget: {
    theme: {
      buttonColor: '#112469',
      dropdownColor: '#112469',
      disabledSwitchColor: '#112469',
      disabledSwitchButtonColor: '#919bc1',
      linkColor: '#112469',
    },
  },
  countriesUrl:
    'https://portal-api.nettest.org/uploads/countries_a13e3c594f.json',
  production: true,
  projectTitle: 'EKIP Nettest',
  logo: {
    header: '/assets/images/logo-header.svg',
    headerSide: null,
    footer: '/assets/images/logo-footer.svg',
    map: null,
  },
  map: {
    center: [19.25, 42.65],
    styleUrl: 'https://tileserver.nettest.com/styles/montenegro_web/style.json',
    ispStyleUrl:
      'https://tileserver.nettest.com/styles/montenegro_isp_web/style.json',
    zoom: 7,
    countiesMaxZoom: 6.5,
    geocoding: {
      url:
        'https://geocode.search.hereapi.com/v1/geocode' +
        '?q={query}' +
        '&at={center}' +
        '&in=countryCode:MNE' +
        '&limit=10' +
        '&apiKey=UcFF6US6mszxDvH1Ske3RwnQb7m-TZwaDcil6WBVkoE',
    },
    municipalitiesMaxZoom: 7.5,
    hexagons10kmMaxZoom: 10,
    hexagons1kmMaxZoom: 12,
    hexagons01kmMaxZoom: 14,
    disableProviderFilter: false,
  },
  mapServer: {
    url: 'https://statistics.nettest.com/api',
    country: 'montenegro',
  },
  municipality: {
    mapLayout: 'horizontal',
  },
  robotsMayIndex: true,
  versionName: 'nettest/portal-frontend',
  recaptchaSiteKey: '6LfWxp8kAAAAADqlZuWchiK47Hyoq-_2cQwG3Dmz',
}
